import {FC, ReactNode} from 'react'
import {isNotEmpty} from '../crud-helper/helpers'

type props = {
  error?: ReactNode
  hint?: ReactNode
}

const InputHint: FC<props> = ({hint, error}) => {
  return (
    <div className='fv-plugins-message-container mt-1 mb-1 mx-3 fs-4'>
      <div className='fv-help-block text-gray-700 fs-6'>
        <div role='alert' className='text-danger'>
          {error}
        </div>
        {hint}
        {!(isNotEmpty(error) || isNotEmpty(hint)) && <>&nbsp;</>}
      </div>
    </div>
  )
}

export {InputHint}
